<template lang="html">
  <div class="docs-search">
    <div class="content-i">
      <div class="content-box">
        <div v-if="(proof == 'proof') && (!searchWithBatchId)" id="no-docs" class="element-box">
          <p class="text-center">{{ t('cantProofSearchWithoutBatchId', 'cantProofSearchWithoutBatchId') }}</p>
        </div>
        <div v-if="((proof == 'proof') && searchWithBatchId) || (proof == 'approved')" class="element-wrapper">
          <h6 class="element-header">{{ t('titleDocumentsSearch','titleDocumentsSearch') }}</h6>

          <div class="element-box">
            <div class="element-info">
              <div class="row">
                <div class="col-12 col-sm-6 col-md-8">
                  <div class="element-info-with-icon">
                    <div class="element-info-icon">
                      <span class="os-icon os-icon-search2"></span>
                    </div>
                    <div class="element-info-text">
                      <h5 class="element-inner-header">{{ t('titleDocumentsSearch','titleDocumentsSearch') }}</h5>
                      <div class="element-inner-desc">{{ t('documentsSearchFormDesc','documentsSearchFormDesc') }}</div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-3 col-md-4">
                  <i id="docuToggle" v-b-toggle.search class="os-icon os-icon-arrow-up float-right text-netsend-blue showhand"></i>
                </div>
              </div>
            </div>
            <b-collapse v-model="visibleSearchBox" id="search" >
              <SearchBar ref="searchBar" :isLoading="isLoading" @search="processSearchAction"/>
            </b-collapse>
            <div v-if="displaySettings.showLogoFiltering && businessUnitInfo" id="business-unit-logos" class="d-flex mt-4">
              <div class="col-lg-12">
                <a v-for="businessUnit in businessUnitInfo" :value="businessUnit.id" :key="businessUnit.id" class="d-inline-block showhand logo-filter">
                  <div v-if="logoFilterStatus(businessUnit.id) === 'turned-off'" @click="toggleBusinessUnitFilter('on', businessUnit.id)" class="logo-filter-block mr-2">
                    <img :src="businessUnit.logoUrl" :alt="businessUnit.name + ' logo'" class="logo-filter logo-filter-off" >
                    <fontAwesomeIcon  :icon="['fas', 'circle']" class="text-white image-select-icon-top-right" size="1x"/>
                  </div>
                  <div v-else class="logo-filter-block logo-filter-block-selected mr-2" @click="toggleBusinessUnitFilter('off', businessUnit.id)">
                    <img :src="businessUnit.logoUrl" :alt="businessUnit.name + ' logo'" class="logo-filter " >
                    <fontAwesomeIcon  :icon="['fas', 'check-circle']" class="text-primary image-select-icon-top-right" size="1x"/>
                  </div>
                </a>
              </div>
            </div>
          </div>

          <div class="element-content" :class="{ hiderender : (noQuery || noDocs) }" v-if="calculations && calculations.documentsSummary && (proof == 'approved')">
            <div class="row">
              <div class="col-sm-12 col-md-12 col-lg-12">
                <div v-if="!isBusyTables" class="element-box">
                  <div class="row">
                    <div class="col-sm-6 b-r b-b">
                      <div class="el-tablo centered padded value-box">
                        <div v-if="showSubValue && calculations.documentsSummary.documentsSubValue" class="value text-primary">
                          {{ calculations.documentsSummary.documentsSubValue | thousandsFormatter() }}
                        </div>
                        <div v-else class="value text-primary">{{ 'N/A' }}</div>
                        <div class="label">{{ t('subTotalLabel','subTotalLabel') }}</div>
                      </div>
                    </div>
                    <div class="col-sm-6 b-b">
                      <div class="el-tablo centered padded value-box">
                        <div v-if="showVatValue && calculations.documentsSummary.documentsVatValue" class="value text-primary">
                          {{ calculations.documentsSummary.documentsVatValue | thousandsFormatter() }}
                        </div>
                        <div v-else class="value text-primary">{{ 'N/A' }}</div>
                        <div v-if="showTaxLabel" class="label">
                          {{ t('taxTotalLabel','taxTotalLabel') }}
                        </div>
                        <div v-else class="label">{{ t('vatTotalLabel','vatTotalLabel') }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-6 b-r">
                      <div class="el-tablo centered padded value-box">
                        <div v-if="showTotalValue && calculations.documentsSummary.documentsTotalValue" class="value text-primary">
                          {{ calculations.documentsSummary.documentsTotalValue | thousandsFormatter() }}
                        </div>
                        <div v-else class="value text-primary">{{ 'N/A' }}</div>
                        <div class="label">{{ t('totalValueLabel','totalValueLabel') }}</div>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="el-tablo centered padded value-box">
                        <div v-if="showTotalValue && calculations.documentsSummary.documentsPageTotal" class="value text-primary">
                          {{ calculations.documentsSummary.documentsPageTotal | thousandsFormatter() }}
                        </div>
                        <div v-else class="value text-primary">{{ 'N/A' }}</div>
                        <div class="label">{{ t('tbdLabel','tbdLabel') }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="element-box">
                  <vcl-table v-if="isBusyTables" :rows="2" :columns="page * perPage"></vcl-table>
                </div>
              </div>
            </div>
          </div>

          <div class="element-content" :class="{ hiderender : (noQuery || noDocs) }" v-if="calculations && calculations.documentsSummary && (proof == 'proof') && (!noDocs)">
            <div class="row">
              <div class="col-sm-12 col-md-8 col-lg-8">
                <div v-if="!isBusyTables" class="element-box">
                  <div class="row">
                    <div class="col-sm-6 b-r b-b">
                      <div class="el-tablo centered padded value-box">
                        <div v-if="showSubValue && calculations.documentsSummary.documentsSubValue" class="value text-primary">
                          {{calculations.documentsSummary.documentsSubValue | thousandsFormatter() }}
                        </div>
                        <div v-else class="value text-primary">{{'N/A'}}</div>
                        <div class="label">{{ t('subTotalLabel','subTotalLabel') }}</div>
                      </div>
                    </div>
                    <div class="col-sm-6 b-b">
                      <div class="el-tablo centered padded value-box">
                        <div v-if="showVatValue && calculations.documentsSummary.documentsVatValue" class="value text-primary">
                          {{calculations.documentsSummary.documentsVatValue | thousandsFormatter() }}
                        </div>
                        <div v-else class="value text-primary">{{'N/A'}}</div>
                        <div v-if="showTaxLabel" class="label">
                          {{ t('taxTotalLabel','taxTotalLabel') }}
                        </div>
                        <div v-else class="label">{{ t('vatTotalLabel','vatTotalLabel') }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-6 b-r">
                      <div class="el-tablo centered padded value-box">
                        <template v-if="showTotalValue">
                          <div v-if="calculations.documentsSummary.documentsPageTotal" class="value text-primary">
                            {{calculations.documentsSummary.documentsPageTotal | thousandsFormatter() }}
                          </div>
                          <div v-else class="value text-primary">{{'N/A'}}</div>
                          <div class="label">{{t('thisPageLabel','thisPageLabel')}} - {{ t('totalValueLabel','totalValueLabel') }}</div>
                          <template v-if="displaySettings.batchGrossValue">
                            <div class="value text-primary">
                              {{ displaySettings.batchGrossValue | thousandsFormatter() }}
                            </div>
                            <div class="label">{{t('thisBatchLabel','thisBatchLabel')}} - {{ t('totalValueLabel','totalValueLabel') }}</div>
                          </template>
                        </template>
                        <template v-else>
                          <div class="value text-primary">{{'N/A'}}</div>
                          <div class="label">{{t('thisPageLabel','thisPageLabel')}} - {{ t('totalValueLabel','totalValueLabel') }}</div>
                        </template>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="el-tablo centered padded value-box">
                        <div v-if="showTotalValue && calculations.documentsSummary.documentsTotalValue" class="value text-primary">
                          {{ calculations.documentsSummary.documentsTotalValue | thousandsFormatter() }}
                        </div>
                        <div v-else class="value text-primary">{{ 'N/A' }}</div>
                        <div class="label">{{ t('totalValueLabel','totalValueLabel') }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="element-box">
                  <vcl-table v-if="isBusyTables" :rows="2" :columns="page * perPage"></vcl-table>
                </div>
              </div>
              <div v-if="(proof == 'proof') && (!noDocs)" class="col-sm-12 col-md-4">
                <div v-if="displaySettings.batchStatus == 'rejected'" class="alert alert-danger borderless">
                  <template >
                      <!--
                      <template v-if="userLevel == 3.00">
                        <b-button size="sm"
                          @click="modalCreator({id: 'ModalGenerateNewProof', title: t('generateNewProofModalHead','generateNewProofModalHead'), open: 'open'}, 'asd', $event.target)"
                          class="float-right">
                            {{ t('buttonTextGenNewProof','buttonTextGenNewProof') }}
                        </b-button>
                      </template>
                    -->
                  </template>
                </div>
                <div v-else class="alert alert-secondary borderless text-white">
                  <template>
                    <h5 class="alert-heading">{{ t('batchApproval', 'batchApproval')}}</h5>
                    <template v-if="displaySettings.batchReference == displaySettings.batchFilename">
                      <p> <strong>{{t('batchRef','batchRef')}}</strong> {{displaySettings.batchReference}} </p>
                      <p> <strong>{{t('fileName','fileName')}}</strong> {{displaySettings.batchFilename}}</p>
                      <p v-if="displaySettings.batchStatus == 'rejected'" class="text-danger"> {{ t('thisProofHasBeenRejected', 'thisProofHasBeenRejected') }}</p>
                    </template>
                    <template v-else>
                      <p> <strong>{{t('batchRef','batchRef')}}</strong> {{displaySettings.batchReference}} </p>
                      <p v-if="displaySettings.batchStatus == 'rejected'" class="text-danger"> {{ t('thisProofHasBeenRejected', 'thisProofHasBeenRejected') }}</p>
                    </template>
                    <form v-on:submit.prevent="approveBatch(batchApproval.approvalChoice, $event.target)" class="d-flex justify-content-end">
                      <b-form-select id="batch-approval-dropdown" class="justify-self-end" v-model="batchApproval.approvalChoice" :text="t('documentToolsButtonText', 'documentToolsButtonText')">
                          <option v-if="displaySettings.allowApproval || displaySettings.batchTestMode" value="approve" selected>{{t('approveAll', 'approveAll')}}</option>
                          <option v-if="(clientName != 'TOTA') || (clientName == 'TOTA' && (Number(userLevel) == 2.50))" value="reject">{{t('rejectAll', 'rejectAll')}}</option>
                      </b-form-select>
                      <button class="btn btn-primary ml-2" type="submit" >{{ t('batchApprovalButtonText','batchApprovalButtonText') }}</button>
                    </form>
                    <template v-if="(!displaySettings.allowApproval) && (!displaySettings.batchTestMode)">
                      <p class="mt-2">{{t('liveBatchApprovalDisabled', 'liveBatchApprovalDisabled')}}</p>
                    </template>
                    <template v-if="displaySettings.batchTestMode">
                      <p class="mt-2">{{t('testMode','testMode')}}: {{displaySettings.batchTestMode}} <br> {{t('testerEmail','testerEmail')}}: {{displaySettings.batchTesterEmail}}</p>
                    </template>
                  </template>
                </div>
              </div>
            </div>
          </div>

          <transition name="fade">
            <div class="scroll-top-div" v-if="showScrollTopButton">
              <button class="btn btn-primary" @click="scrollToTop()">
                <fontAwesomeIcon :icon="['fa', 'arrow-up']" style="color: white;"/>
              </button>
            </div>
          </transition>

          <div class="element-box" :class="{ hiderender : (noQuery || noDocs) }">
            <ToolBar/>
            <div id="results-table">
              <div class="col-12 px-0 mt-2 text-right">
                <button type="button" class="btn btn-secondary" @click="goBack()">{{ t('goBackText', 'goBackText') }}</button>
              </div>
              <div v-if="documents && documents.data" class="controls-below-table pt-4 row">
                  <div class="table-records-info col-lg-6 col-sm-12" v-if="documents.data.length">
                    <p v-if="filter != null && filter.length" class="font-weight-bold mb-0">{{filteredRows}}</p>
                    <p v-else class="mb-0">
                      <template v-if="totalRows == 1">
                      {{totalRows}} {{ t('documentFoundLabel','documentFoundLabel') }}
                      </template>
                      <template v-else>
                      {{totalRows}} {{ t('documentsFoundLabel','documentsFoundLabel') }}
                      </template>
                    </p>
                  </div>
                  <div class="col-lg-4 col-sm-12">
                    <b-pagination v-if="documents.data.length && !infiniteScroll" ref="paginationTop" class="float-right mb-0" @change="manualPagination" :total-rows="totalRows" :per-page="perPage" aria-controls="batches-table">
                    </b-pagination>
                  </div>
                  <div class="col-lg-2 col-sm-12 text-right">
                    <b-input-group class="col-lg-12">
                      <b-input-group-prepend>
                        <label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
                      </b-input-group-prepend>
                      <b-form-select v-model="documentsSearch.per_page" @change="fixInfinitePage" :options="pageOptions"></b-form-select>
                    </b-input-group>
                  </div>
              </div>
              <!-- NS-9848 moved response info here for better UX, PW -->
              <div class="col-12 px-0 mt-3">
                <ResponseInfo class="mb-3 px-0" v-if="getResponseInfo.responseName == 'documentsTool' || getResponseInfo.responseName == 'documentsView'" />
              </div>
              <ResultsTable ref="resultsTable" :tableType="tableType" :isLoading="isLoading" :isInfinite="infiniteScroll" />
              <infinite-loading v-if="!isBusy && infiniteScroll" force-use-infinite-wrapper="true" @infinite="infiniteHandler" slot="append">
                <!-- slot for loading view -->
                <div slot="spinner"></div>
                <div slot="no-more">{{ t('noMoreDocumentsToDisplay', 'noMoreDocumentsToDisplay') }}</div>
              </infinite-loading>
              <div v-if="documents && documents.data" class="controls-below-table pt-4 row">
                  <div class="col-lg-6 col-sm-12 text-left table-records-info" v-if="documents.data.length">
                    <p v-if="filter != null && filter.length" class="font-weight-bold mb-0">{{filteredRows}}</p>
                    <p v-else class="mb-0">
                      <template v-if="totalRows == 1">
                      {{totalRows}} {{ t('documentFoundLabel','documentFoundLabel') }}
                      </template>
                      <template v-else>
                      {{totalRows}} {{ t('documentsFoundLabel','documentsFoundLabel') }}
                      </template>
                    </p>
                  </div>
                  <div class="col-lg-4 col-sm-12">
                    <b-pagination v-if="documents.data.length && !infiniteScroll" ref="paginationBottom" class="float-right mb-0" @change="manualPagination" :total-rows="totalRows" :per-page="perPage" aria-controls="batches-table">
                    </b-pagination>
                  </div>
                  <div class="col-lg-2 col-sm-12 text-right">
                    <b-input-group class="col-lg-12">
                      <b-input-group-prepend>
                        <label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
                      </b-input-group-prepend>
                      <b-form-select id="infinite-bottom" v-model="documentsSearch.per_page" @change="fixInfinitePage" :options="pageOptions"></b-form-select>
                    </b-input-group>
                  </div>
              </div>

              <ModalEmailDoc :modal="this.modal"/>
              <ModalFaxDoc :modal="this.modal"/>
              <ModalPostDoc :modal="this.modal"/>
              <ModalReassignDoc :modal="this.modal"/>
              <ModalNotifyRemittance :modal="this.modal"/>
              <ModalSendDispute :modal="this.modal"/>
              <ModalRaiseQuery :modal="(getModalLevel('query') == 'main')? this.modal : this.subModal"/>
				      <ModalPayment :modal="this.modal"/> <!-- NS-9511: DL - Online payments for V3 -->
              <ModalChangePostHouse :modal="this.modal"/>
              <ModalInfoDoc :modal="(getModalLevel('info') == 'main')? this.modal : this.subModal"/>
              <ModalAcceptBatch :modal="this.modal"/>
              <ModalRejectBatch :modal="this.modal"/>
              <ModalGenerateNewProof :modal="this.modal"/>
              <ModalDeleteDoc :modal="this.modal"/>
              <ModalAlertMessage :forbiddenDocTypes="forbiddenDocTypes" :paidList="paidList" />
              <ModalDownloadData :dataUrl="dataUrl" />
              <ModalInformation :informationTextKey="informationTextKey" :informationTextTitle="informationTextTitle"/>
              <ModalInviteLetters :modal="this.modal" @hide="resetInviteLettersModal"></ModalInviteLetters>
              <div v-if="this.modal['modalData'].open || alertShowing" class="modal-backdrop show"></div>
            </div>
          </div>
          <div v-if="noDocs && !noQuery" id="no-docs" class="element-box">
            <div class="col-12 px-0 mt-2 text-right">
              <button type="button" class="btn btn-secondary" @click="goBack()">{{ t('goBackText', 'goBackText') }}</button>
            </div>
            <p class="text-center">{{ t('noDocsFound', 'noDocsFound') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
//import datePicker from 'vue-bootstrap-datetimepicker'
//import Loading from 'vue-loading-overlay'
import { clientShortName } from '@/helpers/clientShortName.js'
import { backendUrl } from '@/helpers/backendUrl.js'

import ResponseInfo from '@/components/ResponseInfo.vue'

import SearchBar from '@/components/Documents_Search/SearchBar.vue'
import ToolBar from '@/components/Documents_Search/ToolBar.vue'
import ResultsTable from '@/components/Documents_Search/ResultsTable.vue'
import ModalEmailDoc from '@/components/Documents_Search/ModalEmailDoc.vue'
import ModalFaxDoc from '@/components/Documents_Search/ModalFaxDoc.vue'
import ModalPostDoc from '@/components/Documents_Search/ModalPostDoc.vue'
import ModalReassignDoc from '@/components/Documents_Search/ModalReassignDoc.vue'
import ModalNotifyRemittance from '@/components/Documents_Search/ModalNotifyRemittance.vue'
import ModalRaiseQuery from '@/components/Documents_Search/ModalRaiseQuery.vue'
import ModalPayment from '@/components/Documents_Search/ModalPayment.vue' //NS-9511: DL - Online payments for V3
import ModalSendDispute from '@/components/Documents_Search/ModalSendDispute.vue'
import ModalChangePostHouse from '@/components/Documents_Search/ModalChangePostHouse.vue'
import ModalInfoDoc from '@/components/Documents_Search/ModalInfoDoc.vue'
import ModalAcceptBatch from '@/components/Documents_Search/ModalAcceptBatch.vue'
import ModalRejectBatch from '@/components/Documents_Search/ModalRejectBatch.vue'
import ModalGenerateNewProof from '@/components/Documents_Search/ModalGenerateNewProof.vue'
import ModalDeleteDoc from '@/components/Documents_Search/ModalDeleteDoc.vue'
import ModalAlertMessage from '@/components/Documents_Search/ModalAlertMessage.vue'
import ModalDownloadData from '@/components/Helper_Components/ModalDownloadData.vue'
import ModalInformation from '@/components/Helper_Components/ModalInformation.vue'
import ModalInviteLetters from '@/components/Documents_Search/ModalInviteLetters.vue'

import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import { VclTable } from 'vue-content-loading'

export default {
  name: 'documents_search',
  //these functions and values are inheritable from this component
  provide() {
    return {
        //proof: () => this.proof,
        proof: this.proof,
        displaySettings: this.displaySettings,
        //sendTo: this.sendTo,
        //modal functions
        resetModal: this.resetModal,
        modalCreator: this.modalCreator,
        changeModalLevel: this.changeModalLevel,
        getModalLevel: this.getModalLevel,
        subModal: this.subModal,

        //resetInfoSubModal: this.resetInfoSubModal,
        /*
        subModalCreator: this.subModalCreator,
        resetSubModal: this.resetSubModal,
        */

        currentModal: this.modal,
        //search bar
        searchArrays: this.searchArrays,
        userLevel: this.userLevel,
        clientName: this.clientName,
        batchOptions: this.batchOptions,
        pageOptions: this.pageOptions,
        perPage: this.perPage,
        searchDocuments: this.searchDocuments,
        documentsSearch: this.documentsSearch,
        datePickerFormat: this.datePickerFormat,
        //tool bar
        documentTools: this.documentTools,
        documentsData: this.documentsData,

        //results table
        isBusy: this.isBusy,
        isBusyTables: this.isBusyTables,
        getTablesBusy: this.getTablesBusy,
        toggleTablesBusy: this.toggleTablesBusy,

        /*
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
        */

        changeSorting: this.changeSorting,

        totalRows: this.totalRows,
        currentPage: this.currentPage,
        filter: this.filter,
        onFiltered: this.onFiltered,
        rowEmpty: this.rowEmpty,

        checkAllDocs: this.checkAllDocs,
        unCheckAllDocs: this.unCheckAllDocs,
        collectDocStatus: this.collectDocStatus,
        thisDocChecked: this.thisDocChecked,

        isHeadUser: this.isHeadUser,
        headUserCustomerRef: this.headUserCustomerRef,
        changeMark: this.changeMark,
        belongToPrincipal: this.belongToPrincipal,
        totalValueReq: this.totalValueReq,
        vatValueReq: this.vatValueReq,
        markReq: this.markReq,
        displayCurrency: this.displayCurrency,
        userDocTypePaymentAllowed: this.userDocTypePaymentAllowed,
        viewOnlySelected: this.viewOnlySelected,
        processSearchAction: this.processSearchAction
    }
  },
  data() {
    return {
      documentsSearch: {
        page: this.$route.query.page,
        per_page: this.$route.query.per_page,
        batch: this.$route.query.batch,
        doc_type: this.$route.query.doc_type,
        doc_ref: this.$route.query.doc_ref,
        doc_pages: this.$route.query.doc_pages,
        doc_id : this.$route.query.doc_id,
        customer_ref: this.$route.query.customer_ref,
        customer_name: this.$route.query.customer_name,
        date_from : this.$route.query.date_from,
        date_to : this.$route.query.date_to,
        multiple_refs : this.$route.query.multiple_refs ? this.$route.query.multiple_refs : '',
        business_unit_filter: this.$route.query.business_unit_filter,
        batch_status: this.$route.query.batch_status,
        sort_field: this.$route.query.sort_field,
        sort_direction: this.$route.query.sort_direction,

        tasksheet: this.$route.query.tasksheet,
        //client specific filters (from DB)
        client_data_name_1 : this.$route.client_data_name_1,
        client_data_name_2 : this.$route.client_data_name_2,

        mprnGas : this.$route.query.mprnGas, // NS-9566: DL - tota mpan search
        mpanElec : this.$route.query.mpanElec, // NS-9566: DL - tota mpan search
        altPostcode : this.$route.query.altPostcode, // NS-9566: DL - tota mpan search
        exact_search: this.$route.query.exact_search,
        value_from: this.$route.query.value_from,
        value_to: this.$route.query.value_to,
        currency: this.$route.query.currency ? this.$route.query.currency : '',
        vat_from: this.$route.query.vat_from,
        vat_to: this.$route.query.vat_to,
        post_house: this.$route.query.post_house ? this.$route.query.post_house : '',
      },
      searchArrays: {
        batches: [],
        refRange: [],
        docIds: [],
        customerRefs: [],
        multiRefs: '',
        extraFilters: [],
        clientData1: [],
        clientData2: [],
        post_house: [],
        currency: [],
        doc_type: [],
      },
      businessUnitFilter: [],
      isBusy: false,
      isBusyTables: false,
      perPage: 20,
      pageOptions: [10, 20, 50, 100, 500],
      page: 1,
      //sortBy: null,
      //sortDesc: false,
      currentPage: 1,
      lastPage: 1,
      rowEmpty: false,
      filter: null,
      documentTools: {
        toolSelected: null
      },
      batchApproval: {
        approvalChoice: 'approve'
      },
      documentsData: {
        docsChecked: [],
        statuses: []
      },
      searchArray: [],
      //Data storage for the modals
      modal: {
        modalData: {},
        docuData: {},
        updateData: {}
      },
      subModal: {
        modalData: {},
        docuData: {},
        itemData: {},
        updateData: {}
      },
      totalRows: 0,
      noDocs: false,
      noQuery: false,
      visited: false,
      infiniteScroll: false,
      loadMoreData: true,
      showScrollTopButton: false,
      visibleSearchBox: true,
      alertShowing: false,
      forbiddenDocTypes: [],
      paidList: [],
      userDocTypePaymentAllowed: {},
      dataUrl: '',
      informationTextKey: null,
      informationTextTitle: 'informationText',
    }
  },
  computed:{
    ...mapGetters(['allTemplateDetails', 'getResponseInfo']),
    ...mapGetters('documentsStore', ['getDocuments']),
    modalLevelTester() {
      return this.modalLevelInfo
    },
    tableType() {
      if(this.clientSpecificFields) {
        return 'client-specific'
      } else {
        return 'default'
      }
    },
    proof:{
      get() {
        if((this.$route.meta.type) && (this.$route.meta.type == 'proof')) {
          //return true
          return 'proof'
        } else {
          //return false
          return 'approved'
        }
      }
    },
    searchWithBatchId() {
      let hasBatchId = this.$route.query.batch
      if(hasBatchId) {
        return true
      } else {
        return false
      }
    },
    clientName() {
      let clientName = clientShortName()
      return clientName
    },
    isLoading() {
      return this.isBusyTables
    },
    /*
    datePickerFormat: {
      get() {
        let dateformat = this.$store.getters.allTemplateDetails
        dateformat = dateformat.datePickerFormat.replace(/-/g, '/')
        return dateformat
      }
    },*/
    datePickerFormat() {
      if(this.$store.getters.allTemplateDetails && this.$store.getters.allTemplateDetails.datePickerFormat) {
        let dateformat = this.$store.getters.allTemplateDetails.datePickerFormat.replace(/-/g, '/')
        return dateformat
      } else {
        return "DD-MM-YYYY"
      }
    },
    userLevel() {
      return this.$store.getters.getUserLevel
    },
    displaySettings: {
      get() {
        return this.$store.getters['documentsStore/getDisplaySettings']
      },
      set(newDisplaySettings) {
        this.$store.commit('documentsStore/setDisplaySettings', newDisplaySettings)
      }
    },
    businessUnitInfo() {
      return this.$store.getters['documentsStore/getBusinessUnitLogoFilters']
    },
    documents() {
      return this.$store.getters['documentsStore/getDocuments']
    },
    clientSpecificFields() {
      return this.$store.getters['documentsStore/getClientSpecificFields']
    },
    calculations() {
      return this.$store.getters['documentsStore/getCalculations']
    },
    hideDeleteTool() {
      return this.displaySettings.hideDeleteTool
    },
    totalValueReq() {
      return (this.displaySettings.totalValueReq != 0.0) ? true : false
    },
    vatValueReq() {
      return (this.displaySettings.vatValueReq != 0.0) ? true : false
    },
    markReq() {
      return (this.displaySettings.markReq) ? true : false
    },
    cilentMarks() {
      return (this.displaySettings.clientMarks) ? this.displaySettings.clientMarks : false
    },
    displayCurrency() {
      return (this.displaySettings.displayCurrency) ? true : false
    },
    //easy specific
    isHeadUser() {
      return (this.displaySettings.isHeadUser) ? true : false
    },
    //easy specific
    headUserCustomerRef() {
      return this.displaySettings.headUserCustomerRef
    },
    //the per page selector on the search bar changes the variable in the batchEntriesRequest
    //and we need this to watch for changes so we can send a new request each time
    searchPerPage() {
      return this.documentsSearch.per_page
    },
    clientSpecificFilters() {
      return this.$store.getters['documentsStore/getClientSpecificFilters']
    },
    showSubValue: {
      get() {
        return true
        /*return (this.displaySettings.vatValueReq != 0.0)
            && (this.displaySettings.totalValueReq != 0.0) */
      }
    },
    showVatValue: {
      get() {
        // EIPP-429 The conditions were discussed and we decided to remove them PW
        return true
        //return (this.displaySettings.vatValueReq != 0.0 && (this.userLevel >= this.displaySettings.vatValueReq))
      }
    },
    showTaxLabel: {
      get() {
        return ['msdutest', 'msdu', 'corc', 'corctest', 'orgc', 'orgctest', 'lous', 'loustest'].includes(this.clientName)
      }
    },
    showTotalValue: {
      get() {
        // EIPP-429 The conditions were discussed and we decided to remove them PW
        return true
        //return (this.displaySettings.totalValueReq != 0.0 && (this.userLevel >= this.displaySettings.totalValueReq))
      }
    },
    documentTypes() {
      return this.$store.getters['documentsStore/getDocumentTypes']
    },
  },
  watch: {
    searchPerPage() {
      if(this.documentsSearch.per_page !== this.perPage && !this.infiniteScroll) {
        this.perPage = this.documentsSearch.per_page
        this.searchDocuments()
      }
    },
  },
  methods: {
    goBack() {
      this.$router.go(-3)
    },
    // NS-9887 moved the created part into a method that can be accessed by other functions, PW
    createdMethod() {
      if (this.$route.meta && this.$route.meta.query) {
        this.$router.push({ query: { ...this.$route.query, ...this.$route.meta.query} })
      }

      this.modalLevelQuery = 'main'
      this.modalLevelInfo = 'main'

      if((!this.$route.query.batch) && ((this.$route.meta.type) && (this.$route.meta.type == 'proof'))) {
        //if we are on a proof page and there is no batch number, we can't do a search so we exit here
        return
      }

      // EIPP-842 Make batch status set to approved by default in main search, PW
      if((!this.$route.query.batch_status) && (this.proof == 'approved')) {
        this.documentsSearch.batch_status = 'approved'
      }

      let batchIdForProofDisplaySettings = this.$route.query.batch
      //get the variables we base our display conditions on
      this.$store.dispatch('documentsStore/getDocumentSearchDisplaySettings', {batchId: batchIdForProofDisplaySettings})
      .then( data => {
        /*
        if(this.$route.meta.type == 'proof') {
          if (!this.displaySettings.isTester) {
            let status = this.displaySettings.batchStatus
            if(status == 'uploaded') {
              //this.$router.push({path: "/document_creation_management/manage_batches"})
              this.$router.push({name: "manage_batches"})
            }else{
              if(this.displaySettings.parent && this.displaySettings.batchParentStatus == 'uploaded') {
                this.$router.push({name: "manage_batches"})
              }
            }
          }
        }
        */
      })

      //get business unit info
      this.$store.dispatch('documentsStore/getBusinessUnitLogoFilters')

      //get client specific filters for searching
      //then do the main search request
      this.$store.dispatch('documentsStore/getClientSpecificFilters', {view: 'documents'})
      .then( data => {

        /*
        if(this.$route.name == 'last_month') {
          this.$route.query.date_from = moment().startOf('month').format(this.datePickerFormat)
        }*/

        this.allClientSpecificFilters = new Array()
        /*
        for (let i = 0; i < this.clientSpecificFilters.length; i++) {
          Object.keys(this.clientSpecificFilters[i]).forEach(
            (key) => (this.allClientSpecificFilters.push(key))
          )
        }*/

        for (let i = 0; i < data.length; i++) {
          Object.keys(data[i]).forEach(
            (key) => (this.allClientSpecificFilters.push(key))
          )
        }

        if(this.allClientSpecificFilters && Object.keys(this.$route.query).length) {
          for (const property in this.$route.query) {
            if((this.$route.query[property] != undefined) && (this.allClientSpecificFilters.includes(property))) {
              this.documentsSearch[property] = this.$route.query[property]
              this.searchArrays.extraFilters[property] = this.$route.query[property]
            }
          }
        }

        //document types default value
        if (!this.$route.query.doc_type) {
          this.documentsSearch.doc_type = ['all']
          this.searchArrays.doc_type = ['all']
        }

        //we only search for documents when we arrive to the page
        //with at least one query string set
        if(Object.keys(this.$route.query).length && !this.infiniteScroll) {
          //batch or batches list search from query string
          if(this.$route.query.batch) {
            if(Array.isArray(this.$route.query.batch)) {
              let batchKeys = []
              Object.keys(this.$route.query.batch).forEach(
                (key) => (
                  ( batchKeys.push(this.$route.query.batch[key]))
                )
              )
              this.documentsSearch.batch = batchKeys
              this.searchArrays.batches = batchKeys
            } else {
              this.documentsSearch.batch = parseInt(this.$route.query.batch)
              this.searchArrays.batches = parseInt(this.$route.query.batch)
            }
          }

          //document type or type list search from query string
          if (this.$route.query.doc_type) {
            if (!Array.isArray(this.$route.query.doc_type)) {
              this.documentsSearch.doc_type = Array.of(this.$route.query.doc_type)
              this.searchArrays.doc_type = Array.of(this.$route.query.doc_type)
            } else {
              this.documentsSearch.doc_type = this.$route.query.doc_type
              this.searchArrays.doc_type = this.$route.query.doc_type
            }
          } else {
            this.searchArrays.doc_type = ['all']
            this.documentsSearch.doc_type = ['all']
          }

          //document reference or document reference range search from query string
          if(this.$route.query.doc_ref) {
            if(Array.isArray(this.$route.query.doc_ref)) {
              let docRef = []
              Object.keys(this.$route.query.doc_ref).forEach(
                (key) => (
                  ( docRef.push(this.$route.query.doc_ref[key]))
                )
              )
              this.documentsSearch.doc_ref = docRef
              this.searchArrays.refRange = docRef
            } else {
              this.documentsSearch.doc_ref = this.$route.query.doc_ref
              this.searchArrays.refRange = this.$route.query.doc_ref
            }
          }
          //document code or document code list search from query string
          if(this.$route.query.doc_id) {
            if(Array.isArray(this.$route.query.doc_id)) {
              let docId = []
              Object.keys(this.$route.query.doc_id).forEach(
                (key) => (
                  ( docId.push(this.$route.query.doc_id[key]))
                )
              )
              this.documentsSearch.doc_id = docId
              this.searchArrays.docIds = docId
            } else {
              this.documentsSearch.doc_id = this.$route.query.doc_id
              this.searchArrays.docIds = this.$route.query.doc_id
            }
          }
          //customer reference or customer reference range search from query string
          if(this.$route.query.customer_ref) {
            if(Array.isArray(this.$route.query.customer_ref)) {
              let custRef = []
              Object.keys(this.$route.query.customer_ref).forEach(
                (key) => (
                  ( custRef.push(this.$route.query.customer_ref[key]))
                )
              )
              this.documentsSearch.customer_ref = custRef
              this.searchArrays.customerRefs = custRef
            } else {
              this.documentsSearch.customer_ref = this.$route.query.customer_ref
              this.searchArrays.customerRefs = this.$route.query.customer_ref
            }
          }
          //document reference or references list search from query string
          if(this.$route.query.multiple_refs) {
            if(Array.isArray(this.$route.query.multiple_refs)) {
              let multiRef = []
              Object.keys(this.$route.query.multiple_refs).forEach(
                (key) => (
                  ( multiRef.push(this.$route.query.multiple_refs[key]))
                )
              )
              this.documentsSearch.multiple_refs = multiRef
              this.searchArrays.multiRefs = multiRef.toString()
            } else {
              // NS-10016, change to how we process multiple references, had to be done because it would break the search otherwise, PW
              this.documentsSearch.multiple_refs = this.$route.query.multiple_refs
              this.searchArrays.multiRefs = this.$route.query.multiple_refs
            }
          }
          //client data 1 search from query string
          if(this.$route.query.client_data_name_1) {
            if(Array.isArray(this.$route.query.client_data_name_1)) {
              let clientData1 = []
              Object.keys(this.$route.query.client_data_name_1).forEach(
                (key) => (
                  ( clientData1.push(this.$route.query.client_data_name_1[key]))
                )
              )
              this.documentsSearch.client_data_name_1 = clientData1
              this.searchArrays.clientData1 = clientData1.toString()
            } else if(typeof this.$route.query.client_data_name_1 == "string"){
              this.documentsSearch.client_data_name_1 = this.$route.query.client_data_name_1.trim()
              this.searchArrays.clientData1 = this.$route.query.client_data_name_1.trim()
            } else {
              this.documentsSearch.client_data_name_1 = parseInt(this.$route.query.client_data_name_1)
              this.searchArrays.clientData1 = this.$route.query.client_data_name_1
            }
          }
          //client data 2 search from query string
          if(this.$route.query.client_data_name_2) {
            if(Array.isArray(this.$route.query.client_data_name_2)) {
              let clientData2 = []
              Object.keys(this.$route.query.client_data_name_2).forEach(
                (key) => (
                  ( clientData2.push(this.$route.query.client_data_name_2[key]))
                )
              )
              this.documentsSearch.client_data_name_2 = clientData2
              this.searchArrays.clientData2 = clientData2.toString()
            } else if(typeof this.$route.query.client_data_name_2 == "string"){
              this.documentsSearch.client_data_name_2 = this.$route.query.client_data_name_2.trim()
              this.searchArrays.clientData2 = this.$route.query.client_data_name_2.trim()
            } else {
              this.documentsSearch.client_data_name_2 = parseInt(this.$route.query.client_data_name_2)
              this.searchArrays.clientData2 = this.$route.query.client_data_name_2
            }
          }

          //currency search from query string
          if(this.$route.query.currency) {
            if(Array.isArray(this.$route.query.currency)) {
              let currency = []
              Object.keys(this.$route.query.currency).forEach(
                  (key) => (
                      (currency.push(this.$route.query.currency[key]))
                  )
              )
              this.documentsSearch.currency = currency
              this.searchArrays.currency = currency.toString()
            } else if(typeof this.$route.query.currency == "string"){
              this.documentsSearch.currency = this.$route.query.currency.trim()
              this.searchArrays.currency = this.$route.query.currency.trim()
            } else {
              this.documentsSearch.currency = parseInt(this.$route.query.currency)
              this.searchArrays.currency = this.$route.query.currency
            }
          }

          //post_house search from query string
          if(this.$route.query.post_house) {
            if(Array.isArray(this.$route.query.post_house)) {
              let post_house = []
              Object.keys(this.$route.query.post_house).forEach(
                  (key) => (
                      (post_house.push(this.$route.query.post_house[key]))
                  )
              )
              this.documentsSearch.post_house = post_house
              this.searchArrays.post_house = post_house.toString()
            } else if(typeof this.$route.query.post_house == "string"){
              this.documentsSearch.post_house = this.$route.query.post_house.trim()
              this.searchArrays.post_house = this.$route.query.post_house.trim()
            } else {
              this.documentsSearch.post_house = parseInt(this.$route.query.post_house)
              this.searchArrays.post_house = this.$route.query.post_house
            }
          }

          //business unit search from query string
          if(this.$route.query.business_unit_filter) {
            if(Array.isArray(this.$route.query.business_unit_filter)) {
              let businessUnits = []
              Object.keys(this.$route.query.business_unit_filter).forEach(
                (key) => (
                  ( businessUnits.push(this.$route.query.business_unit_filter[key]))
                )
              )
              this.documentsSearch.business_unit_filter = businessUnits
              this.businessUnitFilter = businessUnits
            } else {
              this.documentsSearch.business_unit_filter = parseInt(this.$route.query.business_unit_filter)
              this.businessUnitFilter.push(parseInt(this.$route.query.business_unit_filter))
            }
          }

          //Sorting setup
          if(this.$route.query.sort_field) {
            this.documentsSearch.sort_field = this.$route.query.sort_field
          }
          if(this.$route.query.sort_direction) {
            this.documentsSearch.sort_direction = this.$route.query.sort_direction
          }

          //Pagination setup
          if(this.$route.query.page) {
            this.documentsSearch.page = parseInt(this.$route.query.page)
          } else {
            this.documentsSearch.page = 1
          }

          if(this.$route.query.per_page) {
            this.documentsSearch.per_page = parseInt(this.$route.query.per_page)
          } else {
            this.documentsSearch.per_page = 20
          }

          this.searchDocuments()

        } else {
          //if we arrive to the page without any query strings
          //we wont do a search
          this.documentsSearch.page = 1
          this.documentsSearch.per_page = 20
          this.noDocs = true
          this.noQuery = true
        }

      })

      //we reached the end of the "created" hook
      //this also means the page had been visited
      this.visited = true
    },
    alertMessage(paidList, exceptionsList, forbiddenDocTypes) {
      this.forbiddenDocTypes = forbiddenDocTypes
      this.paidList = paidList
      this.$root.$emit('bv::show::modal', 'alertMessage')
      this.alertShowing = true
    },

    closeAlert() {
      this.$root.$emit('bv::hide::modal', 'alertMessage')
      this.alertShowing = false

      let element = document.getElementsByClassName('bg-danger')
      element[0].scrollIntoView({behavior: "smooth"})
    },

    changeSorting(sortField, sortOrder) {
      if(!this.infiniteScroll) {
        this.$route.query.sort_field = sortField
        this.documentsSearch.sort_field = sortField
        this.$route.query.sort_direction = sortOrder
        this.documentsSearch.sort_direction = sortOrder
        this.searchDocuments()
      }
    },
    /*
    toggleTablesBusy(toggler) {
      if(toggler == 'on') {
        this.isBusyTables = true
      }
      if(toggler == 'off') {
        this.isBusyTables = false
      }
    },*/
    getTablesBusy() {
      return this.isBusyTables
    },
    changeModalLevel(modal, level) {
      switch (modal) {
        case 'info':
          this.modalLevelInfo = level
          break;
        case 'query':
          this.modalLevelQuery = level
          break;
        default:
          break;
      }
    },
    getModalLevel(modal) {
      switch (modal) {
        case 'info':
          return this.modalLevelInfo
          break;
        case 'query':
          return this.modalLevelQuery
          break;
        default:
          break;
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },
    listAllDocuments(check = true) {
      if (check) {
        // if there is more than 1 page that can be displayed then enable infinite scroll
        if (this.totalRows / this.perPage > 1) {
          this.infiniteScroll = true
        }
      } else {
        this.infiniteScroll = true
      }

      this.isBusy = false
      //this.isBusyTables = false
      this.documentsSearch.page = 1
      this.searchDocuments()
    },
    resetInfiniteScroll() {
      // disable infinite scroll
      this.documentsSearch.page = 1
      this.infiniteScroll = false
      this.isBusy = true
      //this.isBusyTables = true
    },
    infiniteHandler($state) {
      // handler used for infinite scroll library, this function will be called when user scrolls to infinite scroll component in template
      if(!this.isBusy && this.documentsSearch.page < this.lastPage && this.infiniteScroll && !this.isBusyTables) {
        this.documentsSearch.page += 1
        this.searchDocuments(true, $state)
      }
      if(this.infiniteScroll && this.documentsSearch.page > 1) {
       this.showScrollTopButton = true
      } else {
        this.showScrollTopButton = false
      }
    },
    onFiltered(filteredItems) {
      this.filteredRows = filteredItems.length
      this.currentPage = 1
    },
    //BUSINESS UNIT FILTER
    logoFilterStatus(unitId) {
      if(this.businessUnitFilter.includes(unitId)) {
          return 'turned-on'
      } else {
          return 'turned-off'
      }
    },
    toggleBusinessUnitFilter(option, unitId) {
      if(option === 'on') {
        this.businessUnitFilter.push(unitId)
      }
      if(option === 'off') {
        this.businessUnitFilter.splice( this.businessUnitFilter.indexOf(unitId), 1 );
      }
      this.searchDocuments()
    },
    //CHECKBOXES FOR DOCUMENTS
    checkAllDocs() {
      let docs = this.documents.data
      let allDocIds = []
      let allDocStatuses = []
      Object.keys(docs).forEach((key) => (allDocIds.push(docs[key].id)))
      Object.keys(docs).forEach((key) => ( allDocStatuses.push( {docId: docs[key].id , status: docs[key].batch_status, customer: docs[key].customer_ref, reference: docs[key].reference} )))
      this.documentsData.docsChecked = allDocIds
      this.documentsData.statuses = allDocStatuses
    },
    unCheckAllDocs() {
      if(this.documentsData) {
        if(this.documentsData.docsChecked) {
          let docs = this.documentsData.docsChecked
          docs.forEach( function(el) {
            document.getElementById('documents-table-client-specific__row_' + el ).classList.remove('bg-danger')
            document.getElementById('documents-table-client-specific__row_' + el ).classList.remove('text-white')
          })
        }
        
      }
      this.documentsData.docsChecked = []
      this.documentsData.statuses = []
    },
    thisDocChecked(docId) {
      if(this.documentsData.docsChecked.includes(docId)){
        return true
      } else {
        return false
      }
    },
    collectDocStatus(event, docStatus) {
        
        // EIPP-572 rework to document check/uncheck
        this.$nextTick(() => {
          let found = this.documentsData.statuses.some(el => el.docId === docStatus.docId)
          // if status not already added AND the selected id is found in checked array
          if(!found && this.documentsData.docsChecked.includes(docStatus.docId)) {
            this.documentsData.statuses.push( docStatus ) 

            if (this.documents.data.length == this.documentsData.statuses.length) {
              this.$refs.resultsTable.localToggle(true)
            }

            // if status is already added and the id is NOT found in checked array ( meaning it was deselected )
          } else if(found && !this.documentsData.docsChecked.includes(docStatus.docId)) {
            let removeKey = null

            for (let index in this.documentsData.statuses) {
              if (this.documentsData.statuses[index].docId == docStatus.docId) {
                  removeKey = index
              }
            }

            if(removeKey) {
              this.documentsData.statuses.splice(removeKey, 1)
              this.$refs.resultsTable.localToggle(false)
            }
          }
        }, this);
    },
    approveBatch(choice, target) {
      let docs = this.documents.data
      let allDocIds = []
      Object.keys(docs).forEach((key) => (allDocIds.push(docs[key].id)))
      if(choice == 'approve') {
        this.modalCreator({id: 'ModalAcceptBatch', title: this.t('batchApprovalAcceptAllModalHead', 'batchApprovalAcceptAllModalHead'), level: 'main', open: 'open'}, allDocIds, target)
      }
      if(choice == 'reject'){
        this.modalCreator({id: 'ModalRejectBatch', title: this.t('batchApprovalRejectAllModalHead', 'batchApprovalRejectAllModalHead'), level: 'main', open: 'open'}, allDocIds, target)
      }
    },
    batchTypesOnPageInclude(batchType) {
      let batchTypesOnPage = []
      for (let i = 0; i < this.documents.data.length; i++) {
        let currentBatchType = this.documents.data[i].batch_name
        batchTypesOnPage.indexOf(currentBatchType) === -1 ? batchTypesOnPage.push(currentBatchType) : null;
      }

      if(batchTypesOnPage.includes(batchType)) {
        return true
      } else {
        return false
      }
    },
    belongToPrincipal(principal) {
      let thePrincipal = principal
      this.$store.dispatch('documentsStore/belongToPrincipal', {
        principal_name: thePrincipal
      })
      .then((data) => {
        return data
      })
    },
    //MODALS
    modalCreator(modalData, docuData, button) {
      if(modalData.level == 'main') {
        //console.log('create - main')
        /*
        if(modalData.id == 'infoModal') {
          //this.modalLevelInfo = 'main'
          //this.changeModalLevel('info', 'main')
        }*/
        /*
        if(modalData.id == 'queryModal') {
          //this.modalLevelQuery = 'main'
          //this.changeModalLevel('query', 'main')
        }*/
        this.modal.modalData = modalData
        this.modal.docuData = { ...docuData }

        this.$root.$emit('bv::show::modal', this.modal.modalData.id, button)
      }
      if(modalData.level == 'sub') {
        //console.log('create - sub')
        /*
        if(modalData.id == 'subInfoModal') {
          //this.modalLevelInfo = 'sub'
          //this.changeModalLevel('info', 'sub')

        }*/
        /*
        if(modalData.id == 'subQueryModal') {
          //this.modalLevelQuery = 'sub'
          //this.changeModalLevel('query', 'sub')
        }*/

        this.subModal.modalData = modalData
        this.subModal.docuData = { ...docuData }
        //this.$root.$emit('bv::hide::modal', this.subModal.modalData.id, button)
        this.$root.$emit('bv::show::modal', this.subModal.modalData.id, button)
      }

    },
    resetModal(level, button = '') {
      if(level == 'main') {
        //console.log('reset - main')
        //this.changeModalLevel('info', 'main')
        //this.changeModalLevel('query', 'main')

        Object.keys(this.modal['modalData']).forEach((key) => (key === 'id') ? this.modal['modalData'][key] : (this.modal['modalData'][key] = '' ))
        Object.keys(this.modal['docuData']).forEach((key) => (this.modal['docuData'][key] = '' ))
        Object.keys(this.modal['updateData']).forEach((key) => (this.modal['updateData'][key] = '' ))
        // NS-9848 We need to show confirmation msgs in documents view for user, PW
        //this.$store.dispatch('alertClearResponse')
      }
      if(level == 'sub') {
        //console.log('reset - sub')
        //this.$root.$emit('bv::hide::modal', this.subModal.modalData.id, button)

        //this.changeModalLevel('info', 'main')
        //this.changeModalLevel('query', 'main')
        Object.keys(this.subModal['modalData']).forEach((key) => (key === 'id') ? this.subModal['modalData'][key] : (this.subModal['modalData'][key] = '' ))
        Object.keys(this.subModal['docuData']).forEach((key) => (this.subModal['docuData'][key] = '' ))
        //Object.keys(this.subModal['itemData']).forEach((key) => (this.subModal['itemData'][key] = '' ))
        Object.keys(this.subModal['updateData']).forEach((key) => (this.subModal['updateData'][key] = '' ))
        // NS-9848 We need to show confirmation msgs in documents view for user, PW
        //this.$store.dispatch('alertClearResponse')
      }
    },

    /*
    subModalCreator(modalData, itemData, button) {
      this.subModal.modalData = modalData
      this.subModal.itemData = { ...itemData }

      this.$root.$emit('bv::show::modal', this.subModal.modalData.id, button)
    },
    resetSubModal() {
      Object.keys(this.subModal['modalData']).forEach((key) => (key === 'id') ? this.subModal['modalData'][key] : (this.subModal['modalData'][key] = '' ))
      Object.keys(this.subModal['itemData']).forEach((key) => (this.subModal['itemData'][key] = '' ))
      Object.keys(this.subModal['updateData']).forEach((key) => (this.subModal['updateData'][key] = '' ))
      this.$store.dispatch('alertClearResponse')
    },*/

    //PAGINATION
    manualPagination(newPage) {
      let page = parseInt(newPage)
      if(this.documentsSearch.page !== page && !this.infiniteScroll) {
        this.documentsSearch.page = page
        this.searchDocuments()
      }

      let paginationTop = this.$refs.paginationTop
      let paginationBottom = this.$refs.paginationBottom

      if(paginationTop) {
        if(this.documentsSearch.page != paginationTop.currentPage) {
          paginationTop.currentPage = this.documentsSearch.page
        }
      }
      if(paginationBottom) {
        if(this.documentsSearch.page != paginationBottom.currentPage) {
          paginationBottom.currentPage = this.documentsSearch.page
        }
      }
    },

    // NS-10044, reset page back to 1 if infinite scroll is on and we manually change records per page, PW
    fixInfinitePage() {
      if(this.infiniteScroll && this.documentsSearch.page > 1) {
        this.documentsSearch.page = 1
        this.infiniteScroll = false
        this.searchDocuments()
      }
    },
    processSearchAction(searchAction) {
      switch (searchAction) {
        case 'list_documents_per_page':
          this.searchDocuments()
          break;
        case 'list_all_documents':
          this.listAllDocuments(false)
          break;
        case 'download-sumcsv':
          this.csvExportByFilter()
          break;
        default:
          this.searchDocuments()
          break;
      }
    },
    csvExportByFilter() {
      this.prepareDocumentSearch()
      this.isBusyTables = true
      this.$store.dispatch('downloadDataStore/prepareFilteredDocumentsInfoCsv', {
        ...this.searchArray,
        proof: this.$route.meta.type,
        user_level: this.userLevel
      }).then(response => {
        this.isBusyTables = false
        if (response.status == 'success' && response.fileUrl) {
          this.dataUrl = backendUrl() + '/downloadDocumentsInfoToCsv/' + response.fileUrl
          this.alertShowing = true
          this.$root.$emit('bv::show::modal', 'downloadModal')
        }
      })
    },
    prepareDocumentSearch() {
      // NS-10009 Update values with the provided data ( it does not seem to be always reactive and this should always return up to date changes ), PW
      if(this._provided && this._provided.searchArrays) {
        this.searchArrays = this._provided.searchArrays
      }

      //search setup - batch
      if (this.searchArrays.batches.length != 0) {
        if ((typeof this.searchArrays.batches == "string") && this.searchArrays.batches.includes(',')) {
          let batchesArray = this.searchArrays.batches.split(",")
          Object.keys(batchesArray).forEach((key) => ( batchesArray[key] = batchesArray[key].trim()))
          batchesArray = batchesArray.filter(function(value, index, arr){
            return value !== "";
          });
          this.searchArrays.batches = batchesArray
        }
        this.documentsSearch.batch = this.searchArrays.batches
        Object.keys(this.documentsSearch.batch).forEach((key) => ((this.documentsSearch.batch[key] == 'all') && (this.documentsSearch.batch[key] = undefined)))
      } else {
        if(this.visited) {
          this.documentsSearch.batch = undefined
        }
      }

      //search view selected documents
      let selectedDocIds = this.$route.params.docs_checked
      if (selectedDocIds) {
        if ((typeof selectedDocIds == "object") && (selectedDocIds.length > 1)) {
          this.documentsSearch.multiple_ids = selectedDocIds
        } else {
          this.documentsSearch.multiple_ids = selectedDocIds[0]
        }
      } else {
        this.documentsSearch.multiple_ids = undefined
      }

      //search setup - doc_ref
      if (this.searchArrays.refRange != 0) {
        /* if((typeof this.searchArrays.refRange == "string") && (this.searchArrays.refRange.includes('-'))){
         let docRef = this.searchArrays.refRange.split("-")
           Object.keys(docRef).forEach((key) => ( docRef[key] = docRef[key].trim() ))
           this.documentsSearch.doc_ref = docRef
         } else { */
        // NS-10009 Removed range split for doc ref, some refs contain - in them so we have to treat every reference as a text, PW
        this.documentsSearch.doc_ref = this.searchArrays.refRange
      } else {
        if(this.visited) {
          this.documentsSearch.doc_ref = undefined
        }
      }

      //search setup - doc_type
      if (this.searchArrays.doc_type && this.searchArrays.doc_type.length > 0) {
        this.documentsSearch.doc_type = this.searchArrays.doc_type
      } else {
        if (this.visited) {
          this.documentsSearch.doc_type = []
        }
      }

      //search setup - doc_id
      if (this.searchArrays.docIds.length != 0) {
        if ((typeof this.searchArrays.docIds == "string") && this.searchArrays.docIds.includes(',')){
          let idsArray = this.searchArrays.docIds.split(",")
          Object.keys(idsArray).forEach((key) => ( idsArray[key] = idsArray[key].trim() ))
          idsArray = idsArray.filter(function(value, index, arr){
            return value !== "";
          });
          this.searchArrays.docIds = idsArray
        } else if(typeof this.searchArrays.docIds == "string") {
          this.searchArrays.docIds = this.searchArrays.docIds.trim()
        }
        this.documentsSearch.doc_id = this.searchArrays.docIds
      } else {
        if (this.visited) {
          this.documentsSearch.doc_id = undefined
        }
      }
      //search setup - customer_ref
      if(this.searchArrays.customerRefs.length != 0) {
        //NS-10978 Removed the range search for "-" customers, RS
        this.documentsSearch.customer_ref = this.searchArrays.customerRefs
      } else {
        if (this.visited) {
          this.documentsSearch.customer_ref = undefined
        }
      }
      //search setup - multiple_refs
      if (this.searchArrays.multiRefs.length != 0) {
        if ((typeof this.searchArrays.multiRefs == "string") && this.searchArrays.multiRefs.includes(',')) {
          let multiRef = this.searchArrays.multiRefs.split(",")
          Object.keys(multiRef).forEach((key) => ( multiRef[key] = multiRef[key].trim() ))
          multiRef = multiRef.filter(function(value, index, arr){
            return value !== "";
          });
          this.documentsSearch.multiple_refs = multiRef
        } else if (this.searchArrays.multiRefs.match(/\n/g)) {
          let multiRef = this.searchArrays.multiRefs.split(/\r?\n/)
          Object.keys(multiRef).forEach((key) => ( multiRef[key] = multiRef[key].trim() ))
          multiRef = multiRef.filter(function(value, index, arr){
            return value !== "";
          });
          this.documentsSearch.multiple_refs = multiRef
        } else if (typeof this.searchArrays.multiRefs == "string") {
          this.documentsSearch.multiple_refs = this.searchArrays.multiRefs.trim()
        } else {
          this.documentsSearch.multiple_refs = this.searchArrays.multiRefs
        }
      } else {
        if (this.visited) {
          this.documentsSearch.multiple_refs = undefined
        }
      }

      //search setup - client_data_name_1
      //for client data 1 range search
      if (this.searchArrays.clientData1) {
        // NS-11317 Disable client data 1 ( discount ) split for TRAV to allow negative search, PW
        if ((typeof this.searchArrays.clientData1 == "string") && this.searchArrays.clientData1.includes('-') && !['trav', 'travtest'].includes(this.clientName)) {
          let clientData1 = this.searchArrays.clientData1.split("-")
          Object.keys(clientData1).forEach((key) => ( clientData1[key] = clientData1[key].trim() ))
          clientData1 = clientData1.filter(function(value, index, arr){
            return value !== "";
          });
          this.documentsSearch.client_data_name_1 = clientData1
        } else {
          this.documentsSearch.client_data_name_1 = this.searchArrays.clientData1
        }
      } else {
        if(this.visited) {
          this.documentsSearch.client_data_name_1 = undefined
        }
      }
      //search setup - client_data_name_2
      //for client data 2 range search
      if (this.searchArrays.clientData2) {
        if ((typeof this.searchArrays.clientData2 == "string") && this.searchArrays.clientData2.includes('-')) {
          let clientData2 =this.searchArrays.clientData2.split("-")
          Object.keys(clientData2).forEach((key) => ( clientData2[key] = clientData2[key].trim() ))
          clientData2 = clientData2.filter(function(value, index, arr){
            return value !== "";
          });
          this.documentsSearch.client_data_name_2 = clientData2
        } else {
          this.documentsSearch.client_data_name_2 = this.searchArrays.clientData2
        }
      } else {
        if(this.visited) {
          this.documentsSearch.client_data_name_2 = undefined
        }
      }

      //search setup - currency
      if (this.searchArrays.currency) {
        if ((typeof this.searchArrays.currency == "string") && this.searchArrays.currency.includes(',')) {
          let currency =this.searchArrays.currency.split(',')
          Object.keys(currency).forEach((key) => ( currency[key] = currency[key].trim() ))
          currency = currency.filter(function(value, index, arr){
            return value !== "";
          });
          this.documentsSearch.currency = currency
        } else {
          this.documentsSearch.currency = this.searchArrays.currency
        }
      } else {
        if (this.visited) {
          this.documentsSearch.currency = undefined
        }
      }

      //search setup - post_house
      if (this.searchArrays.post_house) {
        if ((typeof this.searchArrays.post_house == "string") && this.searchArrays.post_house.includes(',')) {
          let post_house =this.searchArrays.post_house.split(',')
          Object.keys(post_house).forEach((key) => ( post_house[key] = post_house[key].trim() ))
          post_house = post_house.filter(function(value, index, arr){
            return value !== "";
          });
          this.documentsSearch.post_house = post_house
        } else {
          this.documentsSearch.post_house = this.searchArrays.post_house
        }
      } else {
        if (this.visited) {
          this.documentsSearch.post_house = undefined
        }
      }

      if (this.$route.query.last_month) {
        // NS-9887 get date from 30 days ago ( last month ) for quick filter, PW
        this.documentsSearch.date_from = moment().subtract(30, 'days').format(this.datePickerFormat)
      }

      // NS-9887 "Change request" page filters, VY
      if (['newsnet', 'newsnettest'].includes(this.clientName)) {
        if (this.$route.query.tasksheet) {
          this.documentsSearch.tasksheet = true
        }

        if (this.$route.query.list_by) {
          if (this.documentTypes && this.documentTypes.length > 0) {
            let type = this.documentTypes.find(({ name }) => name.toLowerCase() === 'change request')
            if (type) {
              let formattedType = Array.of(type.id)
              this.documentsSearch.doc_type = formattedType
              this.searchArrays.doc_type = formattedType
            } else {
              this.documentsSearch.doc_type = ['all']
              this.searchArrays.doc_type = ['all']
            }
          }
        }
      }

      if (this.$route.query.online_statements) {
        this.searchArrays.extraFilters['payment_status'] = 'unpaid'
        this.searchArrays.extraFilters['online_statements'] = true
      }

      //search setup - client specific filters
      if (Object.keys(this.searchArrays.extraFilters).length != 0) {
        //assigning the client specific filter values to the main search
        for (const property in this.searchArrays.extraFilters) {
          this.documentsSearch[property] = this.searchArrays.extraFilters[property]
          this.searchArray[property] = this.searchArrays.extraFilters[property]
        }
      } else {
        if (this.visited) {
          for (const property in this.searchArrays.extraFilters) {
            this.documentsSearch[property] = undefined
            this.searchArray[property] = undefined
          }
        }
      }

      if (this.businessUnitFilter.length != 0) {
        this.documentsSearch.business_unit_filter = this.businessUnitFilter
      }

      //Sorting setup
      if (this.$route.query.sort_field) {
        this.documentsSearch.sort_field = this.$route.query.sort_field
      }
      if (this.$route.query.sort_direction) {
        this.documentsSearch.sort_direction = this.$route.query.sort_direction
      }

      Object.keys(this.documentsSearch).forEach((key) => ((this.documentsSearch[key] == '') || (this.documentsSearch[key] == null)) && (this.documentsSearch[key] = undefined))
      // NS-10009 Clear route parameters before calling next search, that way it should update new params without any issues like values not updating properly, PW
      this.$router.replace({ query: null})
      this.$router.push({ query: { ...this.$route.query, ...this.documentsSearch, page: this.documentsSearch.page, per_page: this.documentsSearch.per_page} })
      Object.keys(this.documentsSearch).forEach((key) => (this.searchArray[key] = this.documentsSearch[key]))
    },
    //THE MAIN SEARCH QUERY
    searchDocuments($appendResults = false, $state = null) {
      //NS-10737, when infinite scrolling is enabled, after any action that performs the search again,
      // we load all data from the first page to the current page, VY
      let appendAfterAction = false

      this.isBusyTables = true

      if(typeof $appendResults == 'undefined' || typeof $appendResults != 'boolean') {
        $appendResults = false;
      }

      if (!$appendResults) {
        if (this.infiniteScroll) {
          appendAfterAction = true
        }
        this.isBusy = true
      }

      this.prepareDocumentSearch()

      this.$store.dispatch('documentsStore/getDocuments', {
        ...this.searchArray,
        per_page: this.$route.query.per_page,
        append_results: $appendResults,
        append_after_action: appendAfterAction,
        proof: this.$route.meta.type,
        user_level: this.userLevel
      })
      .then(() => {

        if(this.$route.meta.type == 'proof') {
          if (!this.displaySettings.isTester) {
            let status = this.displaySettings.batchStatus
            let parent = this.displaySettings.parent
            let parentStatus = this.displaySettings.batchParentStatus
            if(status == 'uploaded' || (parent && (parentStatus == 'uploaded'))) {
              this.$router.push({path: "/document_creation_management/manage_batches"})
            }
          }
        }

        this.isBusyTables = false
        this.isBusy = false
        this.noQuery = false
        this.loadMoreData = true

        if($appendResults) {
          this.infiniteScroll = true
        }

        //if we try to access a page that has no entries because it's after the last page
        //we set the pagination back to default and fetch the batches with the correct pagination
        if(this.documents.current_page > this.documents.last_page && this.documents.total > 0) {
          this.documentsSearch.page = 1
          this.documentsSearch.per_page = 20
          this.searchDocuments()
        }

        this.lastPage = this.documents.last_page
        this.totalRows = this.documents.total

        if($state != null) {
          $state.loaded()
        }

        if((Object.entries(this.documents.data).length === 0) || (this.documents.data === undefined)) {
          this.noDocs = true
          this.rowEmpty = true
          this.loadMoreData = false
          if($state != null) {
            $state.complete()
          }
        } else {
          this.noDocs = false
          this.visibleSearchBox = false
        }

        //setting the pagination manually
        this.currentPage = parseInt(this.documentsSearch.page)
        this.perPage = parseInt(this.documentsSearch.per_page)

        this.manualPagination(parseInt(this.documentsSearch.page))
        if(this.documents.current_page >= this.documents.last_page) {
          this.loadMoreData = false
          if($state != null) {
            $state.complete()
          }
        }

        if(this.infiniteScroll && this.documents.data && this.documents.data[Object.entries(this.documents.data).length] > 15) {
          document.getElementById("documents-table-client-specific__row_" + this.documents.data[Object.entries(this.documents.data).length - 15].id).scrollIntoView();
        }

        //vuejs throws and error if the multi select options is not an array
        //so we make sure there it gets an array, even if it's empty
        if(!this.documentsSearch.batch) {
          this.documentsSearch.batch = new Array()
        }
        this.$route.params.docs_checked = undefined
        this.documentsData.docsChecked = []

        // NS-9848 Remove clear response because the user couldnt see any confirmation msgs from actions taken in modals for example, PW
        //this.$store.dispatch('alertClearResponse')

          this.documentsData.docsChecked = [] // EIPP-572 clear checked docs after search, PW
          this.documentsData.statuses = []
          this.$refs.resultsTable.localToggle(false)
      })
    },
    viewOnlySelected(docsChecked) {
      // NS-10739 reset page back to 1, VY
      this.$route.params.docs_checked = docsChecked
      this.documentsSearch.page = 1

      this.searchDocuments()
    },
    resetInviteLettersModal(level, dataUrl = null, button = '') {
      this.resetModal(level, button)

      if (dataUrl) {
        this.dataUrl = dataUrl
        this.alertShowing = true
        this.$root.$emit('bv::show::modal', 'downloadModal')
      }
    }
  },
  created() {
    // NS-9887 Moved the created code into a method that can be accessed from other functions if needed, PW
    this.createdMethod()
  },
  beforeDestroy() {
    this.visited = false
    this.noQuery = true
    this.docs = []
  },
  filters: {
    numberFormat: function(number, digits) {
      return Number.parseFloat(number).toFixed(digits)
    },
    thousandsFormatter: function(value) {
      if(value) {
        // EIPP-429, added formatting, PW
        if(typeof value == "string") {
          value = value.replaceAll(",", "")
        }
        
        return Number.parseFloat(value).toLocaleString('en', {
          minimumFractionDigits: 2,      
          maximumFractionDigits: 2,
        });
      }

      return value
      
    },
  },
  components: {
    //Loading,
    SearchBar,
    ToolBar,
    ResultsTable,
    ResponseInfo,
    ModalEmailDoc,
    ModalFaxDoc,
    ModalPostDoc,
    ModalReassignDoc,
    ModalNotifyRemittance,
    ModalRaiseQuery,
	  ModalPayment, //NS-9511: DL - Online payments for V3 
    ModalSendDispute,
    ModalChangePostHouse,
    ModalInfoDoc,
    ModalAcceptBatch,
    ModalRejectBatch,
    ModalGenerateNewProof,
    VclTable,
    ModalDeleteDoc,
    ModalAlertMessage,
    ModalDownloadData,
    ModalInformation,
    ModalInviteLetters
  }
}
</script>

<style lang="css" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 1.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
/*-----SEARCH BAR-----*/
.text-netsend-blue{
  color: #047bf8;
}
.docu-search-border{
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 10px;
  border-radius: 10px;
}
#docuToggle{
  font-size: 1.2rem;
  font-weight: bold;
  display:inline-block;
  -moz-transition: all .5s linear;
  -webkit-transition: all .5s linear;
  transition: all .5s linear;
}
#docuToggle.collapsed{
  -moz-transform:rotate(180deg);
  -webkit-transform:rotate(180deg);
  transform:rotate(180deg);
}

.showhand{
  cursor: pointer;
}

/*
Used for rendering but hiding the results table and it's pagination,
this way we can access the rendered pagination $ref-s in the manual pagination function
when we arrive to the page without a query string (and therefore have no results to show)
*/
.hiderender{
  display:none;
}

/*BUSINESS UNIT LOGO FILTERS*/
#business-unit-logos{
  height: 70px;
  overflow: auto;
  white-space: nowrap;
}
.logo-filter{
  height: 50px;
  border-radius: 5px;
}
.logo-filter-off{
  -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
  filter: grayscale(100%);
}
.logo-filter-block{
  box-shadow: 0px 2px 4px rgba(126, 142, 177, 0.12);
  border-radius: 5px;
}
.logo-filter-block-selected{
  border: 1px solid #047bf8;
}
.image-select-icon-top-right{
  vertical-align:top;
  padding: 1px;
}

 /*TOTAL CARDS*/
.tablo-header{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 62px;
  width: 62px;
  background-color: #047bf8;
  color: white;
  font-size: 2rem;
  font-weight: bold;
  border-radius: 50%;
}
.tablo-width {
  max-width: 250px;
  margin: 2px;
}
.tablo-width  >>> p{
  padding-top: 5px;
  padding-bottom: 5px;
}
.tablo-width  >>> p.brand-color {
  background-color: #047bf8 !important;
  color: white !important;
}
.value-box {
  position: relative;
}
.icon-div {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bg-icon {
  font-size: 100px;
  opacity: 0.05;
  color: black;
}
.scroll-top-div {
  position: fixed;
  right: 50px;
  bottom: 50px;
  width: 50px;
  height: 50px;
  z-index: 100;
}
.scroll-top-div > button {
  height: 100%;
  width: 100%;
  font-size: 24px;
}
</style>
